import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';
import { COMPARE_MODAL } from 'components/Catalog/ProductGrid/CompareModal/constants';
import { Text } from 'components/ui';
import Icon from 'components/Icon';
import { colors } from 'style/config';

const DELIVERY_TYPES = {
    BOPIS: 'bopis',
    GIS: 'gis',
    SDD: 'sdd'
};

const PickupAndDeliveryZone = ({
    skus = [], getText = () => {}, storeName, zipCode, showStoreSwitcherModal, showShippingDeliveryLocationModal
}) => {
    const handleOpenStoreModal = e => {
        e.preventDefault();
        e.stopPropagation();

        showStoreSwitcherModal({
            isOpen: true,
            showStoreDetails: true,
            entry: 'product compare tool',
            componentName: COMPARE_MODAL
        });
    };

    const handleOpenShippingDeliveryLocationModal = e => {
        e.preventDefault();
        e.stopPropagation();

        showShippingDeliveryLocationModal({
            isOpen: true
        });
    };

    const InStock = () => (
        <Text
            lineHeight={'none'}
            fontSize='sm'
            fontWeight='bold'
            color={colors.green}
        >
            <Icon
                name='checkmark'
                size={12}
                marginRight={2}
            />
            {getText('inStock')}
        </Text>
    );

    const OutOfStock = () => (
        <Text
            lineHeight={'none'}
            fontSize='sm'
            fontWeight='bold'
            color={colors.red}
        >
            <Icon
                name='x'
                size={12}
                marginRight={2}
            />
            {getText('outOfStock')}
        </Text>
    );

    const renderSubsectionTitle = type => {
        const showChangeStoreModal = type === DELIVERY_TYPES.BOPIS;
        const zip = zipCode ? zipCode : getText('setLocation');

        return (
            <Text
                is='button'
                lineHeight={'tight'}
                onClick={e => (showChangeStoreModal ? handleOpenStoreModal(e) : handleOpenShippingDeliveryLocationModal(e))}
            >
                {getText(type)}
                {showChangeStoreModal ? storeName : zip}
                <Icon
                    name='caretDown'
                    size={12}
                    marginLeft={1}
                />
            </Text>
        );
    };

    const renderSubsectionContent = _product => {
        const isOutOfStock = false; // TODO: FER-416: Get actual stock status from product data

        return isOutOfStock ? <OutOfStock /> : <InStock />;
    };

    const subsections = [
        {
            type: DELIVERY_TYPES.BOPIS,
            renderTitle: renderSubsectionTitle,
            renderContent: renderSubsectionContent
        },
        {
            type: DELIVERY_TYPES.GIS,
            renderTitle: renderSubsectionTitle,
            renderContent: renderSubsectionContent
        },
        {
            type: DELIVERY_TYPES.SDD,
            renderTitle: renderSubsectionTitle,
            renderContent: renderSubsectionContent
        }
    ];

    return (
        <CompareZoneBase
            skus={skus}
            getText={getText}
            titleKey='pickupAndDelivery'
            subsections={subsections}
        />
    );
};

PickupAndDeliveryZone.propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func,
    storeName: PropTypes.string,
    showStoreSwitcherModal: PropTypes.func
};

export default wrapFunctionalComponent(PickupAndDeliveryZone, 'PickupAndDeliveryZone');
